/**
 * Deckbuilder Card Themes & Chassis Definitions
 *
 * Supported chassis styles:
 * 1. 'glass'   - Cyber Glass (Default, monolithic crystal glass chassis with Arcade Plunger appeal and Overdrive pips)
 * 2. 'fluted'  - Fluted (Micro-Pinstripe edition with fine vertical ribbing, unlockable via Supply Surge)
 * 3. 'holo'    - Holo (Pearlescent Liquid Crystal chassis with organic topography curves, unlockable via Supply Surge)
 * 4. 'classic' - Classic Steel (Original military gunmetal plating, unlockable via Supply Surge)
 * 5. 'artwork' - Artwork (Pure canvas artwork with no fonts, infos, texts, or frames — only the 1-2-3 contour remains)
 *
 * Extensible for future versions (e.g. Mecha Hex, Tactical Pad, etc.).
 */

export const DECKBUILDER_THEMES = [
  {
    id: 'glass',
    name: 'Cyber Glass',
    subtitle: 'Monolithic Crystal Chassis',
    description: 'Massives monolithisches Kristallglas-Chassis mit Arcade-Plunger-Hub, Carbon-Armor-Lünette und Overdrive-Pips.',
    isDefault: true,
    unlockedByDefault: true,
    surgeReward: false
  },
  {
    id: 'fluted',
    name: 'Fluted',
    subtitle: 'Micro-Pinstripe Crystal Chassis',
    description: 'Massives monolithisches Kristallglas-Chassis mit feiner Nadelstreifen-Riffelung (Mikro-Riffelglas), Carbon-Armor-Lünette und Overdrive-Pips.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  },
  {
    id: 'holo',
    name: 'Holo',
    subtitle: 'Liquid Crystal Topography Chassis',
    description: 'Monolithisches Cyber-Glass mit irisierendem Holo-Flüssigkristall, organischen Topo-Rillen (Fingerabdruck-Maserung) und Overdrive-Pips.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  },
  {
    id: 'classic',
    name: 'Classic Steel',
    subtitle: 'Original Military Plating',
    description: 'Originales militärisches Gunmetal-Chassis mit vertiefter Kachel und Laser-Dividers.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  },
  {
    id: 'artwork',
    name: 'Artwork',
    subtitle: 'Pure Canvas Edition',
    description: 'Pures Karten-Artwork ohne Schriften, Statuswerte, Overlays oder Rahmen — einzig die 1-2-3-Kopienkontur bleibt sichtbar.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  }
];

export function getDeckbuilderThemeById(id) {
  return DECKBUILDER_THEMES.find(t => t.id === id) || DECKBUILDER_THEMES[0];
}
